import React from 'react';
import {
    List,
    Filter,
    Datagrid,
    BooleanField,
    TextInput,
    TextField,
    BooleanInput,
    EditButton,
    ShowButton,
    DateField,
    ReferenceField,
} from 'react-admin';
import {ProviderTypesField} from "./partials/ProviderTypes";
import {ProviderTablespacesField} from "./partials/ProviderTablespaces";

const ProviderFilter = props => (
    <Filter {...props}>
        <TextInput source="q" label="Search" alwaysOn />
        <BooleanInput source="is_active" label="Is Active"/>
    </Filter>
);


export const ProviderList = props =>
        <List title="Providers" sort={{ field: 'created_at', order: 'DESC' }} filters={<ProviderFilter />} {...props} >
            <Datagrid>
                <ReferenceField source="user_id" reference="admin/user" label="User"><>
                    <TextField source="first_name" />{' '}
                    <TextField source="last_name" /></>
                </ReferenceField>
                <TextField source="user.email" />
                <BooleanField source="is_active" />
                <ProviderTypesField label="Types" />
                <ProviderTablespacesField label="Tablesapces" />
                <TextField source="title" />
                <TextField source="acuity_calendar_id" />
                <DateField source="created_at" label="Created"/>
                <DateField source="updated_at" label="Updated"/>
                <EditButton />
                <ShowButton />
            </Datagrid>
        </List>


